meedy.controller('meedy.officeListController', ['$rootScope', '$scope', '$state', '$mdToast', '$mdDialog', '$translate', 'meedy.objectHelper', 'applicationModel', 'meedy.userModel', 'meedy.resourceModel',
    function ($rootScope, $scope, $state, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, userModel, resourceModel) {

        var MAX_OFFICESS_NUMBER = 99;

        function setData() {
            $scope.offices = [];
            $scope.criteria = new ResourceDataGridMeedyCriteria();
            $scope.criteria.rowsPerSheet = 99;

            $scope.columns = [
                {
                    field: "name",
                    displayName: $translate.instant('T.MEEDY.MODULE.OFFICE.OFFICE_NAME')
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.OFFICE.ADDRESS'),
                    cellTemplate: 'meedy/application/view/app/settings/office/grid-template/data-office-list-address.html'
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.OFFICE.ACTION'),
                    cellTemplate: 'meedy/application/view/app/settings/office/grid-template/data-office-list-delete-office.html'
                }
            ];

            $scope.currentState = Constant.STATE.APP.MEEDY.SETTINGS.OFFICE.LIST;
            $scope.Constant = Constant;
        }

        function setPermissions() {
            $scope.isPhysician = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN;
            $scope.isReceptionist = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST
            ||  userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST;
        }

        function setListeners() {
            $scope.$on(Event.MEEDY.RESOURCE.GET_DATA_PAGE.SUCCESS, function(event, dataPage) {
                $scope.offices = dataPage.data;
                $scope.numberOfPages = dataPage.numberOfPages;
                // autoamtic edit view for viprotect purpose
                if(userModel.currentUser.originSystem === Enum.ORIGIN_SYSTEM.MEEDY_PROTECT){
                    $scope.editOffice($scope.offices[0]);
                }
            });

            $scope.$on(Event.MEEDY.RESOURCE.DELETE.SUCCESS, function(event, offices) {
                resourceModel.getDataPage($scope.criteria);
            });

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });
        }

        function setActions() {

            $scope.createNewOffice = function() {
                if($scope.offices.length >= MAX_OFFICESS_NUMBER) {
                    $rootScope.$broadcast(Event.MEEDY.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.MAX_OFFICES_NUMBER_REACHED'));
                } else {
                    $state.go(Constant.STATE.APP.MEEDY.SETTINGS.OFFICE.CREATE);
                }
            };

            $scope.editOffice = function(office) {
                $state.go(Constant.STATE.APP.MEEDY.SETTINGS.OFFICE.EDIT, {id : office.id});
            };

            $scope.deleteOffice = function(office) {
                var confirm = $mdDialog.confirm({
                    title: $translate.instant('T.MEEDY.MODULE.OFFICE.OFFICE_DELETE_CONFIRMATION'),
                    ok: $translate.instant('T.MEEDY.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.MEEDY.UI.APPLICATION.NO')
                });
                $mdDialog.show(confirm).then(function() {
                    resourceModel.delete(office.id);
                }, function() {
                    return false;
                });
            };

            $scope.criteriaChanged = function() {
                resourceModel.getDataPage($scope.criteria);
            };
        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.SETTINGS.MY_DATA);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.SETTINGS');
        }

        function initialize() {
            resourceModel.getDataPage($scope.criteria);
            applicationModel.viewReady = true;
            applicationModel.fillViewportMode = true;
            if($scope.isPhysician) {
                $scope.showAddButton($scope.createNewOffice);
            }
            $scope.hideBackButton();
            $scope.resetTitle();
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
